<template>
  <div class="job-card" v-on:click="openModal()">
    <img :src="profileImage"
      @error="setDefaultImage"
      @click.stop="this.$router.push(`/org/${job?.company.handle}`)"
     alt="Company logo"
    class="logo" />
    <div class="details">
      <router-link class="company" style="text-decoration:none;color:var(--foreground);" @click.stop :to="`/org/${job?.company.handle}`">
        
        <div class="job-title">
          {{ job?.jobTitle }}
        </div>
        <div class="company-name">
          {{ job.company?.name }}
        </div>
      </router-link>
      <div class="type job-detail">
        <BriefcaseJobIcon class="job-icon"/><div class="detail">{{ job?.jobType || '--' }}</div>
      </div>
      <div class="location job-detail">
        <PinIcon class="job-icon"/><div class="detail">{{ job?.location }}</div> 
      </div>
      
      <div class="closing-date job-detail">
        <CalendarIcon class="job-icon"/> <div class="detail">{{ job?.closingDate }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BriefcaseJobIcon from '../IconComponents/BriefcaseJobIcon.vue';
import CalendarIcon from '../IconComponents/CalendarIcon.vue';
import PinIcon from '../IconComponents/PinIcon.vue';
export default {
  components:{
    BriefcaseJobIcon,CalendarIcon,PinIcon
  },
  data(){
    return{
      url:process.env.VUE_APP_API_URL
    }
  },
  computed:{
    profileImage(){
      if (!this.job || !this.job.company || !this.job.company.id) {
        return require('@/assets/images/profile_picture.png');
      }
      return this.url + 'Auth/Image/' + this.job.company.id;
    }
  },
  methods: {
    setDefaultImage(event) {
      event.target.src = require('@/assets/images/profile_picture.png');
    },
     getListItem(){
      return this.job;
    }
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    openModal: {
        type: Function,
        required: true
    }
  }
 
};
</script>

<style scoped>

.job-detail{
  display: flex;
  align-items: center;
  color:var(--darkgrey3);
}



.detail{
  font-family: var(--body-font);
  font-size:0.7rem;
  
}

.job-icon{
  height:1rem;
  margin-right:0.4rem;
  margin-top:-0.2rem;
  color:var(--darkgrey3);
}

.job-card {
  display: flex;
  align-items: flex-start;
  /* border: 1px solid var(--lightgrey2); */
  padding: 0.5rem;
  border-radius: 6px;
  background: var(--list-item);
  margin-bottom: 0.5rem;
  cursor: pointer;
  color:var(--foreground);
}

.logo {
  width: 60px;
  height: 60px;
  margin-right: 1rem;
  border-radius: 4px;
  object-fit: cover;
}

.details{
  margin-top:-0.3rem;
}

.details h3 {
  margin: 0;
  font-size: 1.1rem;
}

.description{
    white-space: pre-line;
}

.company{
  /* font-weight: bold;
  font-size:1.2rem; */
  display:grid;
  grid-template-rows:auto auto;
}

.company:hover{
  text-decoration:underline!important;
}



.company-name{
  font-family: var(--page-header-font);
  font-size:0.9rem;
  margin-bottom:0.4rem;
  white-space:wrap;
}

.job-title{
   font-family: var(--page-header-font);
   font-size:1.1rem;
   color:var(--job-title);
   white-space:wrap;

}

.location, .type, .closing-date{
  font-family: var(--heading-font2-regular);
}

/* Mobile layout */
@media (max-width: 768px) {
 

  .details {
    width: 100%;
    margin-left: 0.3rem;
    margin-top:-0.2rem;
  }

  .details h3 {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  .logo {
    margin-right: 0.5rem;
    margin-bottom:0.7rem;
  }

  /* Put logo + title side by side */
 

  .job-card > .logo,
  .job-card > .details h3 {
    display: inline-block;
    vertical-align: middle;
  }

  .description {
    display: block;
    margin-top: 0.4rem;
    width: 100%; /* full width for description */
  }

  .job-card {
 
  padding: 0.7em;
  background: var(--list-item);
  margin-bottom: 0.7rem;

}

.company{
  font-size:1.1rem;
}

.location, .type, .closing-date{
  color:var(--text-grey);
  font-size:0.9rem;
}

.job-title{  
   font-size:1rem;
}
}
</style>